module.exports = __webpack_public_path__ + "assets/img/bg-home-more.0c2c1cb5.png";